<app-courses title="Rejected" status="rejected"></app-courses>